// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3RezH","footer":"ModalCreateQualiphyProcedure_footer__qyQfh","additionData":"ModalCreateQualiphyProcedure_additionData__T884F"};